import { Layout as BaseLayout } from 'antd';
import styled from 'styled-components';

export const Content = styled(BaseLayout.Content)``;
